import { defineStore } from "pinia"
import { AssessmentState } from "@/models/assessmentState"

export const useAssessmentStore = defineStore("assessment", {
	state: (): AssessmentState => ({
		selectedAssessment: null,
		selectedStep: null,
		isLocked: false,
		lockedBy: null,
	}),

	actions: {
		setSelectedAssessment(assessment: string): void {
			this.selectedAssessment = assessment
		},
		setSelectedStep(step: string): void {
			this.selectedStep = step
		},
		setLockStatus(isLocked: boolean, lockedBy: string | null = null): void {
			this.isLocked = isLocked
			this.lockedBy = lockedBy
		},
	},

	getters: {
		getCurrentAssessment: (state): string | null => state.selectedAssessment,
		getCurrentStep: (state): string | null => state.selectedStep,
		isAssessmentLocked: (state): boolean => state.isLocked,
		getLockedBy: (state): string | null => state.lockedBy,
	},
})
